import {createContext, useCallback, useContext, useRef} from "react";

import {ResponsiveModalPart} from "../../utils/create_responsive_modal_height_animator";

interface IResponsiveModalContext {
    onClose: () => void;
    registerPart: (part: ResponsiveModalPart, element: HTMLElement) => () => void;
}

export const ResponsiveModalContext = createContext<IResponsiveModalContext | null>(null);

export const useResponsiveModalContext = () => {
    const context = useContext(ResponsiveModalContext);

    if (!context) {
        throw new Error("ResponsiveModal compound components must be rendered inside ResponsiveModal");
    }

    return context;
};

export const useResponsiveModalPartRef = (part: ResponsiveModalPart) => {
    const {registerPart} = useResponsiveModalContext();
    const unregisterRef = useRef<(() => void) | null>(null);

    return useCallback(
        (element: HTMLElement | null) => {
            unregisterRef.current?.();
            unregisterRef.current = element ? registerPart(part, element) : null;
        },
        [part, registerPart]
    );
};
import {createContext, useCallback, useContext, useRef} from "react";

import {ResponsiveModalPart} from "../../utils/create_responsive_modal_height_animator";

interface IResponsiveModalContext {
    onClose: () => void;
    registerPart: (part: ResponsiveModalPart, element: HTMLElement) => () => void;
}

export const ResponsiveModalContext = createContext<IResponsiveModalContext | null>(null);

export const useResponsiveModalContext = () => {
    const context = useContext(ResponsiveModalContext);

    if (!context) {
        throw new Error("ResponsiveModal compound components must be rendered inside ResponsiveModal");
    }

    return context;
};

export const useResponsiveModalPartRef = (part: ResponsiveModalPart) => {
    const {registerPart} = useResponsiveModalContext();
    const unregisterRef = useRef<(() => void) | null>(null);

    return useCallback(
        (element: HTMLElement | null) => {
            unregisterRef.current?.();
            unregisterRef.current = element ? registerPart(part, element) : null;
        },
        [part, registerPart]
    );
};
